/**
 * Joins a configured service base URL with a request path.
 *
 * The base comes from the environment, so whether it carries a trailing slash is outside this
 * code's control. Interpolating it straight into a template literal turns `https://host/` into
 * `https://host//api/v1/...`, which NestJS routes as a distinct, unregistered path and answers
 * with a 404 that looks like a missing endpoint rather than a malformed URL.
 */
export function apiUrl(baseUrl: string, path: string): string {
  const base = baseUrl.replace(/\/+$/, '');
  const suffix = path.replace(/^\/+/, '');
  return `${base}/${suffix}`;
}
